export const getTextLogo = (colorScheme: string) => {
  return colorScheme === "dark"
    ? "/logo/text-super-agents-dark.svg"
    : "/logo/text-super-agents-light.svg";
};

export default getTextLogo;
